/* eslint-disable */
import * as Yup from 'yup';
import { useState, useEffect } from 'react';
// material
import {
    Container, Card,
    Autocomplete, FormControl, InputLabel, Checkbox, InputAdornment, FormHelperText
} from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, Button, Box, Grid } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import SearchNotFound from '../../../SearchNotFound';
import services from '../Services';
import permissionAuth from 'src/utils/permissionAuth';
import TokenDecoder from 'src/helpers/TokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import PropTypes, { func } from 'prop-types'
import { useTheme } from '@mui/material/styles'
import { parseInt, truncate } from 'lodash';
import Chip from '@material-ui/core/Chip';
import Select from '@material-ui/core/Select';
import ClearIcon from '@mui/icons-material/Clear';

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

export default function PricingListing() {
    const screenCode = 'PRICING';
    let encrypted = "";
    const navigate = useNavigate();
    const [skuCategory, setSkuCategory] = useState([]);
    const [selectedProductOption, setSelectedProductOption] = useState(0);
    const [isFarmerClear, setIsFarmerClear] = useState(false);
    const [selectedProductCategory, setSelectedProductCategory] = useState(0);
    const [IsClear, setIsClear] = useState(false);
    const [autocompleteKey, setAutocompleteKey] = useState(0);
    const [sku, setSku] = useState([]);
    const [grade, setGrade] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState([]);
    const [groupList, setGroupList] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [formData, setFormData] = useState({
        groupID: "0",
        productCategoryID: '',
        productID: '',
        gradeID: '',
        percentage: '',
        additionValue: '',
        flatValue: ''
    });
    const [pageProps, setPageProps] = useState({
        editingID: 0,
        isEdit: true,
        pageheadername: 'Pricing'
    });
    const [globalValues, setGlobalValues] = useState({
        percentage: '',
        flatValue: '',
        additionValue: '',
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false
    });
    const GroupSearchSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please select a Group').required('Group Required'),
        productCategoryID: Yup.number().min(1, 'Please Select Product Category').required('Product Category Required'),
        productID: Yup.string().required('Product ID is required')
        // gradeID: Yup.string().required('Grade ID is required'),
    });

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            productCategoryID: selectedProductCategory.productCategoryID,
            productID: formData.productID,
            gradeID: selectedOptions,
            percentage: formData.percentage,
            additionValue: formData.additionValue,
            flatValue: formData.flatValue
        },
        validationSchema: GroupSearchSchema,
        onSubmit: (values) => {
            trackPromise(GetPricingDetails());

        },
    });

    const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tableData.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleGlobalChange = (e, field) => {
        const value = e.target.value;
        setGlobalValues(prev => ({
            ...prev,
            [field]: value
        }));
    };

    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        GetAllGroups();
        trackPromise(GetSkuCategories());
    }, []);

    useEffect(() => {
        setSku([]);
        setTableData([]);
        formik.setFieldValue('gradeID', '');
        formik.setFieldValue('productID', '');
        formik.setFieldValue('productCategoryID', '');
        setIsClear(!IsClear);
        setAutocompleteKey((prevKey) => prevKey + 1);
        setValues({
            ...values,
            productCategoryID: '',
            productID: ''
        });
        setIsFarmerClear(!isFarmerClear);
        setTableData([]);
        setSelectedProductOption(0)
        setSelectedProductCategory(0)
    }, [formik.values.groupID]);

    useEffect(() => {
        trackPromise(GetSkuDetails());
    }, [formik.values.productCategoryID]);

    useEffect(() => {
        formik.setFieldValue('productID', '');
        setAutocompleteKey((prevKey) => prevKey + 1);
        setValues({
            ...values,
            productCategoryID: selectedProductCategory,
            productID: ''
        });
        setIsFarmerClear(!isFarmerClear);
        setTableData([]);
        setSelectedProductOption(0)
    }, [formik.values.productCategoryID]);

    useEffect(() => {
        setValues({
            ...values,
            productID: selectedProductOption
        });
        setIsFarmerClear(!isFarmerClear);
        setTableData([]);
    }, [formik.values.productID]);

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDPRICING');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find((p) => p.permissionCode == 'GROUPDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
        })
        trackPromise(GetSkuCategories());
        trackPromise(GetGradeDetails());
    }

    async function GetAllGroups() {
        var resNew = await services.GetAllGroupsForMarketScreen();
        if (resNew != null) {
            setGroupList(resNew);
        }
    }

    async function GetPricingDetails() {
        let model = {
            groupID: formik.values.groupID,
            skuCategoryID: formik.values.productCategoryID,
            skuID: formik.values.productID,
            gradeID: selectedOptions.map(x => x).join(',').toString(),
        }
        var res = await services.GetPricingDetails(model);
        if (res != null) {
            setTableData(res.data);
        }
        setPage(0);
    }

    function clearAll() {
        setValues({
            ...values,
            productCategoryID: '',
            productID: '',
            gradeID: ''
        })
        setIsClear(!IsClear);
        setAutocompleteKey((prevKey) => prevKey + 1);
        formik.resetForm();
        setTableData([])

    }

    async function GetSkuCategories() {
        var result = await services.GetSkuCategories()
        result.forEach(x => {
            x.productCategoryName = x.productCategoryName == null || x.productCategoryName == "" ? x.categoryCode : x.productCategoryName
        })
        setSkuCategory(result);
    }

    async function GetSkuDetails() {
        var res = await services.GetPricingDetailsBySkuCategoryID(formik.values.productCategoryID)
        if (res != null) {
            setSku(res);
        }
    }

    async function GetGradeDetails() {
        var res = await services.GetGradeDetails()
        if (res != null) {
            var newOptionArray = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray.push({ label: res[i].gradeName, value: res[i].gradeID })
            }
            setGrade(newOptionArray);
        }
    }

    function handleSearchDropdownChangePrefferdName(data, e) {
        if (data === undefined || data === null) {
            setSelectedCategory(data);
            setValues({
                ...formik.values,
                productCategoryID: '0'
            });
            return;
        } else {
            setSelectedCategory(data);
            var nameP = 'productCategoryID';
            var valueP = data.productCategoryID;
            setValues({
                ...formik.values,
                productCategoryID: valueP
            });
            setSelectedProductCategory(valueP);
        }
    }

    function handleSearchCrop(data, e) {
        if (data === undefined || data === null) {
            setValues({
                ...formik.values,
                productID: 0,
            });
        } else {
            setValues({
                ...formik.values,
                productID: data.productID,
            });
            setSelectedProductOption(data.productID);
        }
    }

    const handleSelectChange = (event) => {
        const value = event.target.value;
        if (value.includes("")) {
            setSelectedOptions(
                selectedOptions.length === grade.length ? [] :
                    grade.map((option) => option.value)
            );
        } else {
            // setSelectedOptions(value);
            setSelectedOptions([value[value.length - 1]]);
        }
    };

    const filterOptions = (options, { inputValue }) => {
        const trimmedInput = inputValue.trim().toLowerCase();

        const filteredOptions = options.filter(option =>
            (option.productCategoryName && option.productCategoryName.toLowerCase().includes(trimmedInput))
        ).filter(option => option.productCategoryName !== null);

        const exactMatchOptions = [];
        const nonExactMatchOptions = [];
        filteredOptions.forEach(option => {
            if (
                option.productCategoryName.toLowerCase() === trimmedInput
            ) {
                exactMatchOptions.push(option);
            } else {
                nonExactMatchOptions.push(option);
            }
        });
        return exactMatchOptions.length > 0 ? exactMatchOptions : nonExactMatchOptions;
    };

    const handleChange = (e, i, field) => {
        const { value } = e.target;

        const newArr = [...tableData];
        newArr[i] = { ...newArr[i], [field]: value == "" ? parseFloat(0) : parseFloat(value) };
        setTableData(newArr)

    };

    async function SaveAllPricingDetails() {
        const createdBy = parseInt(TokenDecoder.getUserIDFromToken());

        const pricingDetails = tableData.map(row => ({
            groupID: parseInt(values.groupID),
            skuCategoryID: parseInt(values.productCategoryID),
            skuID: parseInt(values.productID),
            gradeID: row.gradeID,
            // wacPrice: parseFloat(row.wacPrice),
            percentage: selectedOptions.length === grade.length
                ? parseFloat(globalValues.percentage || 0)
                : parseFloat(row.percentage || 0),
            flatValue: selectedOptions.length === grade.length
                ? parseFloat(globalValues.flatValue || 0)
                : parseFloat(row.flatValue || 0),
            additionValue: selectedOptions.length === grade.length
                ? parseFloat(globalValues.additionValue || 0)
                : parseFloat(row.additionValue || 0),
            // sellingPrice: parseFloat(row.price),
            createdBy: createdBy,
        }));

        const res = await services.SavePricingDetails(pricingDetails);
        if (res != null) {
            setTableData([]);
            toast.success(res.message);
        }
        setPage(0);
    }


    const renderSelectedValue = (selected) => {
        if (selected.length === 0) {
            return '';
        } else if (selected.length === 1) {
            const option = grade.find((entity) => entity.value === selected[0]);
            return option ? <Chip label={option.label} /> : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = grade.find((entity) => entity.value === value);
                    return option ? <Chip label={option.label} /> : null;
                } else {
                    const option = grade.find((entity) => entity.value === value);
                    return option ? <Chip key={index} label={option.label} /> : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    const handleClearSelection = () => {
        setSelectedOptions([]);
    };

    useEffect(() => {
        setPage(0);
        if (selectedOptions.length > 0) {
            trackPromise(GetGradeDetails());
        } else {
            trackPromise(GetAllGroups());
        }
    }, []);

    useEffect(() => {
        setTableData([]);
    },[selectedOptions]);


    return (
        <>
            <LoadingComponent />
            <Page title="Pricing |  FAPS">
                <Container>
                    <CommonPageHeader pageName={pageProps.pageheadername} leftButtonHidden={true} />
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                            <Stack spacing={2}>
                                <Stack spacing={2}>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                        <Grid item md={4} xs={12}>
                                            <TextField
                                                select
                                                fullWidth
                                                size="small"
                                                label="Group *"
                                                value={formik.values.groupID}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('groupID')}
                                                error={Boolean(touched.groupID && errors.groupID)}
                                                helperText={touched.groupID && errors.groupID}
                                                InputProps={{
                                                    readOnly: !permissionList.isGroupFilterEnabled
                                                }}
                                            >
                                                <MenuItem key={0} value={0}>Select Group</MenuItem>
                                                {groupList.map((option) => (
                                                    <MenuItem key={option.groupID} value={option.groupID}>
                                                        {option.groupName}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        </Grid>
                                        <Grid item md={4} xs={12}>
                                            <Autocomplete
                                                fullWidth
                                                key={IsClear}
                                                id="productCategoryID"
                                                options={skuCategory}
                                                filterOptions={filterOptions}
                                                getOptionLabel={(option) => option.productCategoryName || ''}
                                                onChange={(e, value) => {
                                                    handleSearchDropdownChangePrefferdName(value, e);
                                                    formik.setFieldValue('productID', '');
                                                }}
                                                renderInput={(params) =>
                                                    <TextField {...params}
                                                        variant="outlined"
                                                        name="productCategoryID"
                                                        label="Sku Category *"
                                                        size="small"
                                                        fullWidth
                                                        value={formik.values.productCategoryID}
                                                        helperText={touched.productCategoryID && errors.productCategoryID}
                                                        error={Boolean(touched.productCategoryID && errors.productCategoryID)}
                                                    />
                                                }
                                            />
                                        </Grid>
                                        <Grid item md={4} xs={12}>
                                            <Autocomplete
                                                fullWidth
                                                key={autocompleteKey}
                                                id="productID"
                                                options={sku}
                                                getOptionLabel={(option) => option.productName || ''}
                                                onChange={(e, value) => handleSearchCrop(value, e)}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        variant="outlined"
                                                        name="productID"
                                                        label="Sku *"
                                                        size="small"
                                                        fullWidth   
                                                        value={formik.values.productID}
                                                        helperText={touched.productID && errors.productID}
                                                        error={Boolean(touched.productID && errors.productID)}
                                                    />
                                                )}
                                            />
                                        </Grid>

                                        <FormControl fullWidth error={Boolean(touched.gradeID && errors.gradeID)}>
                                            <InputLabel id="multi-select-label">Grade *</InputLabel>
                                            <Select
                                                className="custom-select"
                                                labelId="multi-select-label"
                                                id="multi-select"
                                                multiple
                                                size="small"
                                                value={selectedOptions}
                                                onChange={handleSelectChange}
                                                label="Grade *"
                                                renderValue={(selected) => renderSelectedValue(selected)}
                                            >
                                                <MenuItem key={0} value={""}>
                                                    <Checkbox checked={selectedOptions.length === grade.length} color="primary" />
                                                    All Grades
                                                </MenuItem>
                                                {grade.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                        <Checkbox checked={selectedOptions.indexOf(option.value) > -1} color="primary" />
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                            {touched.gradeID && errors.gradeID && (
                                                <FormHelperText>{errors.gradeID}</FormHelperText>
                                            )}
                                            {selectedOptions.length > 0 && (
                                                <IconButton onClick={handleClearSelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                    {!permissionList.isFactoryFilterEnabled ? null :
                                                        <ClearIcon />}
                                                </IconButton>
                                            )}
                                        </FormControl>
                                    </Stack>

                                    <Grid >
                                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                            <Button
                                                type="button"
                                                color='error'
                                                variant="outlined"
                                                onClick={() => clearAll()}
                                            > Clear</Button>
                                            <Button
                                                type="submit"
                                                color='secondary'
                                                variant="outlined"
                                            >Search</Button>
                                        </Stack>
                                    </Grid>
                                </Stack>
                            </Stack>
                        </Form>
                    </FormikProvider>
                    <br />
                    {tableData.length == 0 ?
                        <SearchNotFound searchQuery="Pricing" />
                        :
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                            <Card style={{ justifycontent: 'center', width: '85rem' }} >
                                <TableContainer component={Paper} >
                                    <Table aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="left">SKU Code</TableCell>
                                                <TableCell align="left">Description</TableCell>
                                                <TableCell align="left">Grade</TableCell>
                                                <TableCell align="right">WAC Price</TableCell>
                                                <TableCell align="right">Percentage</TableCell>
                                                <TableCell align="right">Flat Value</TableCell>
                                                <TableCell align="center">Addition Value</TableCell>
                                                <TableCell align="center">Selling Price</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {selectedOptions.length === grade.length ? (
                                                <TableRow>
                                                    <TableCell align="left" component="th" scope="row">
                                                        -
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        Applies to ALL Grades
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        ALL Grades
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        -
                                                    </TableCell>

                                                    <TableCell align="right">
                                                        <TextField
                                                            size='small'
                                                            type="number"
                                                            value={globalValues.percentage || ''}
                                                            onChange={(e) => handleGlobalChange(e, 'percentage')}
                                                            InputProps={{
                                                                inputProps: {
                                                                    step: 0.01,
                                                                },
                                                            }}
                                                        />
                                                    </TableCell>

                                                    <TableCell align="right">
                                                        <TextField
                                                            size='small'
                                                            type="number"
                                                            value={globalValues.flatValue || ''}
                                                            onChange={(e) => handleGlobalChange(e, 'flatValue')}
                                                            InputProps={{
                                                                inputProps: {
                                                                    step: 0.01,
                                                                },
                                                            }}
                                                        />
                                                    </TableCell>

                                                    <TableCell align="center">
                                                        <TextField
                                                            size='small'
                                                            type="number"
                                                            value={globalValues.additionValue || ''}
                                                            onChange={(e) => handleGlobalChange(e, 'additionValue')}
                                                        />
                                                    </TableCell>

                                                    <TableCell align="center">
                                                        -
                                                    </TableCell>
                                                </TableRow>
                                            ) : (
                                                (rowsPerPage > 0
                                                    ? tableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                    : tableData
                                                ).map((row, i) => (
                                                    <TableRow key={row.index}>
                                                        <TableCell align="left" component="th" scope="row" size='small'>
                                                            {row.skuCode}
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            {row.description}
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            {row.gradeName}
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            {row.wacPrice}
                                                        </TableCell>

                                                        <TableCell align="right">
                                                            <TextField
                                                                size='small'
                                                                type="number"
                                                                value={row.percentage || ''}
                                                                onChange={(e) => handleChange(e, i, 'percentage')}
                                                                InputProps={{
                                                                    inputProps: {
                                                                        step: 0.01,
                                                                    },
                                                                }}
                                                            />
                                                        </TableCell>

                                                        <TableCell align="right">
                                                            <TextField
                                                                size='small'
                                                                type="number"
                                                                value={row.flatValue || ''}
                                                                onChange={(e) => handleChange(e, i, 'flatValue')}
                                                                InputProps={{
                                                                    inputProps: {
                                                                        step: 0.01,
                                                                    },
                                                                }}
                                                            />
                                                        </TableCell>

                                                        <TableCell align="center">
                                                            <TextField
                                                                size='small'
                                                                type="number"
                                                                value={row.additionValue || ''}
                                                                onChange={(e) => handleChange(e, i, 'additionValue')}
                                                            />
                                                        </TableCell>

                                                        <TableCell align="center">
                                                            {row.price}
                                                        </TableCell>
                                                    </TableRow>
                                                ))
                                            )}

                                            {emptyRows > 0 && (
                                                <TableRow style={{ height: 53 * emptyRows }}>
                                                    <TableCell colSpan={6} />
                                                </TableRow>
                                            )}
                                        </TableBody>


                                        <TableFooter>
                                            <TableRow>
                                                <TablePagination
                                                    rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                                    colSpan={6}
                                                    count={tableData.length}
                                                    rowsPerPage={rowsPerPage}
                                                    page={page}
                                                    SelectProps={{
                                                        inputProps: {
                                                            'aria-label': 'rows per page',
                                                        },
                                                        native: true,
                                                    }}
                                                    onPageChange={handleChangePage}
                                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                                    ActionsComponent={TablePaginationActions}
                                                />
                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                    <Grid container>
                                        <Stack
                                            direction={{ xs: 'column', sm: 'row' }}
                                            margin={'10px'}
                                            justifyContent="flex-end"
                                            width="100%"
                                        >
                                            <Button
                                                onClick={(e) => SaveAllPricingDetails()}
                                                color="secondary"
                                                variant="outlined"
                                            >
                                                Save
                                            </Button>
                                        </Stack>
                                    </Grid>

                                </TableContainer>
                            </Card>
                        </Stack>
                    }
                </Container>
            </Page>
        </>
    );
}